import React from 'react';
import { Link } from 'react-router-dom';

const cx = (...v) => v.filter(Boolean).join(' ');

const variants = {
  primary: 'cc-btn cc-btn-primary',
  ghost: 'cc-btn cc-btn-ghost',
  subtle: 'cc-btn cc-btn-subtle',
  danger: 'cc-btn cc-btn-danger',
};

export default function UIButton({ as = 'button', variant = 'primary', className = '', children, ...props }) {
  const base = 'inline-flex items-center justify-center gap-2 px-3.5 py-2 text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-50';
  if (as === 'link') {
    return <Link className={cx(base, variants[variant] || variants.primary, className)} {...props}>{children}</Link>;
  }
  return <button className={cx(base, variants[variant] || variants.primary, className)} {...props}>{children}</button>;
}
